/** @format */

export enum themeBreakpoints {
  sm = 567,
  md = 768,
  lg = 1159,
}
